module.exports = __webpack_public_path__ + "static/media/arrowdownwardamber.f295699f.svg";